module.exports = __webpack_public_path__ + "static/media/ai-translations-traveler-jun25.a698a60f.md";